module.exports = __webpack_public_path__ + "img/swiper3.4038576a.jpg";